import { render, staticRenderFns } from "./MenuBottom.vue?vue&type=template&id=46cba045&scoped=true&"
import script from "./MenuBottom.vue?vue&type=script&lang=js&"
export * from "./MenuBottom.vue?vue&type=script&lang=js&"
import style0 from "./MenuBottom.vue?vue&type=style&index=0&id=46cba045&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cba045",
  null
  
)

export default component.exports